<template>
	<footer class="layout-footer">
		<b-container>
			<ul class="links">
				<li>
					<img src="/img/eyes.svg" alt="skilldoo"/>
				</li>
				<li>&copy; {{year}} by skilldoo</li>
				<li v-if="withLogin">
					<a href="/auth/login" target="_blank">Login</a>
				</li>
				<li>
					<a href="/info/datenschutz" target="_blank">Datenschutz</a>
				</li>
				<li>
					<a href="/info/agb" target="_blank">AGBs</a>
				</li>
				<li>
					<a href="/info/nutzungsbedingungen" target="_blank">Nutzungsbedingungen</a>
				</li>
				<li>
					<a href="/info/impressum" target="_blank">Impressum</a>
				</li>
				<li>
					<a href="#" target="_blank" @click.prevent="showConsentPopUp">Cookies</a>
				</li>
				<li class="d-md-none">
					<a href="#" @click.prevent="openFeedback">Feedback</a>
				</li>
			</ul>
		</b-container>
	</footer>
</template>

<script>
import {DateTime} from "luxon";
import EventBus from "@/event/EventBus";
import * as Event from "@/event/Event";

export default {

	props: {
		withLogin: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	computed: {
		year ()
		{
			return DateTime.now().year;
		}
	},

	methods: {
		showConsentPopUp ()
		{
			EventBus.$emit(Event.SHOW_CONSENT);
		},
		openFeedback ()
		{
			EventBus.$emit(Event.SHOW_FEEDBACK);
		}
	}
}
</script>
